import React, { useState } from 'react';
import './LandingPage.css';
import NavBar from './components/NavBar';
import Bumpups from './components/Bumpups';
import Timestamp from './components/Timestamp';
import Footer from './components/Footer';

const LandingPage = () => {
  const [updateTrigger, setUpdateTrigger] = useState(0);
  return (
    <div className="landing-page">
      <NavBar />
      <div className="global-container">
        <Timestamp onGenerateSuccess={() => setUpdateTrigger(prev => prev + 1)} />
        <Bumpups updateTrigger={updateTrigger} />
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;

